<template>
    <div>
        <p class="fw-semibold fs-5 mb-3">
            {{ message }}
        </p>

        <div class="border-top pt-2">
            <div>
                <p>{{ $t("device.label") }}: <strong>{{ notification.device_name }}</strong></p>
            </div>
            <div>
                <p>{{ $t("device.batteryStatus") }}: <strong>{{ notification.data.battery_level }} %</strong></p>
            </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
            <button
                v-if="!notification.is_resolved"
                class="btn btn-success btn-sm me-2"
                @click="$emit('resolved')"
                :title="$t('notifications.markAsResolved')"
            >
                <span class="text-white fs-6 fw-bold p-3">{{ $t("utils.solve") }}</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        notification: Object,
    },
    computed: {
        message() {
            const levelKey =
                this.notification.level === "critical"
                    ? "messageCritical"
                    : "messageWarning"

            return this.$t(`notifications.battery.${levelKey}`, {
                device: this.notification.device_name,
                battery: this.notification.data.battery_level
            })
        }
    }
}
</script>